import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

export const SENTINEL_SETUP_SCRIPT_FILENAME = 'zenity-sentinel-setup.sh';

@Component({
  selector: 'app-sentinel-automated-setup',
  templateUrl: './sentinel-automated-setup.component.html',
  styleUrls: ['./sentinel-automated-setup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SentinelAutomatedSetupComponent {
  @Output() downloadScriptRequested = new EventEmitter<Event | undefined>();

  public readonly scriptFilename = SENTINEL_SETUP_SCRIPT_FILENAME;

  public onDownloadScript(event?: Event): void {
    this.downloadScriptRequested.emit(event);
  }
}
